function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container, ContainerIcon } from './elements';
/**
 * A Button comes in three possible sizes and six visual sizes.
 * An Icon component can be displayed next to the text label of the button, left or right side.
 * For now, instance of the Icon must be passed to the Button so styling is rather free.
 *
 * Button can be a simple standalone button or part of a form.
 *
 * @return {jsx}
 */

var Button = function Button(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      fluid = _ref.fluid,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      size = _ref.size,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "className", "disabled", "fluid", "icon", "iconPosition", "onClick", "size", "type"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    appearance: appearance,
    className: className,
    disabled: disabled,
    fluid: fluid,
    icon: icon,
    iconPosition: iconPosition,
    onClick: onClick,
    size: size,
    type: type
  }, rest), displayIcon(iconPosition, icon), children);
};
/**
 * displayIcon
 *
 * This function is a helper to place
 * the icon correctly inside a button.
 * He return an react element with the
 * good props: left or right.
 *
 * @param {string} side // The side where the icon should be positioned [left or right].
 * @param {jsx} icon // The icon elements.
 *
 * @return {jsx}
 */


var displayIcon = function displayIcon(side, icon) {
  if (!side || !icon) return null;
  return {
    left: /*#__PURE__*/React.createElement(ContainerIcon, {
      left: true
    }, icon),
    right: /*#__PURE__*/React.createElement(ContainerIcon, {
      right: true
    }, icon)
  }[side];
};
/**
 * PropTypes Validation.
 */


var bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    oneOf = PropTypes.oneOf,
    string = PropTypes.string;
Button.propTypes = {
  /**
   * The base styling to apply to the button
   */
  appearance: oneOf(['default', 'primary', 'secondary', 'success', 'failure', 'google']),

  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: node,

  /**
   * ClassName needed by styled components
   */
  className: string,

  /**
   * Whether the button is disabled or not
   */
  disabled: bool,

  /**
   * Whether the button is fluid or not
   */
  fluid: bool,

  /**
   * Adds icon next to the text button to illustrate it
   */
  icon: node,

  /**
   * Sets the icon position compared to the text. It will be set to the left side by default
   */
  iconPosition: string,

  /**
   * Handler of click on the button
   */
  onClick: func,

  /**
   * Whether the button size is small, default or large. It will be set to `default` by default
   */
  size: oneOf(['small', 'default', 'large']),

  /**
   * Whether it is a button or a form submission
   */
  type: oneOf(['button', 'submit'])
};
/**
 * Default props.
 */

Button.defaultProps = {
  appearance: 'default',
  children: null,
  className: '',
  disabled: false,
  fluid: false,
  icon: null,
  iconPosition: 'left',
  onClick: function onClick() {},
  size: 'default',
  type: 'button'
};
var styledButton = styled(Button).withConfig({
  displayName: "Button__styledButton",
  componentId: "ubycnm-0"
})([""]);
styledButton.displayName = 'Button';
export default styledButton;